module.exports = __webpack_public_path__ + "fonts/group_42969_1_1.svg";